require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/Matthew/git/evolutionofcannabis/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/Matthew/git/evolutionofcannabis/node_modules/babel-plugin-lodash/lib/index.js\",\"/Users/Matthew/git/evolutionofcannabis/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/Matthew/git/evolutionofcannabis/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[[\"/Users/Matthew/git/evolutionofcannabis/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/Users/Matthew/git/evolutionofcannabis/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/Matthew/git/evolutionofcannabis/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./post.jsx") })
        }
      }, "component---src-templates-post-jsx");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=component---src-templates-post-jsx!./src/templates/post.jsx
// module id = 415
// module chunks = 231608221292675